import React from 'react';
import BaseTestCardDuration, { BaseTestCardDurationProps } from './BaseTestCardDuration';
import BaseTestCardTagCloud, { BaseTestCardTagCloudProps } from './BaseTestCardTagCloud';

export interface BaseTestCardContentProps extends BaseTestCardTagCloudProps, BaseTestCardDurationProps {}

function BaseTestCardContent({
    testType,
    topics,
    totalTopicsCount,
    duration,
    isPreviewQuestionsLoading,
    toggleDialog,
}: BaseTestCardContentProps): React.JSX.Element {
    return (
        <div className="row-span-1 flex h-full flex-col justify-between gap-4 p-2.5">
            <BaseTestCardTagCloud topics={topics} totalTopicsCount={totalTopicsCount} testType={testType} />
            <BaseTestCardDuration
                toggleDialog={toggleDialog}
                isPreviewQuestionsLoading={isPreviewQuestionsLoading}
                duration={duration}
            />
        </div>
    );
}

export default BaseTestCardContent;
